import html2canvas from 'html2canvas';

/**
 * Rasterise a DOM node to a high-DPI PNG blob and filename.
 * - scale:2 for crisp mobile viewing.
 * - useCORS enabled so remote product thumbnails render.
 */
export async function nodeToPngBlob(node, filename) {
    const canvas = await html2canvas(node, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        imageTimeout: 15000,
    });
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 0.95));
    return { blob, filename };
}

export async function downloadReceipt(node, orderNumber) {
    const { blob, filename } = await nodeToPngBlob(
        node,
        `BeautyByChancy-${orderNumber || 'receipt'}.png`
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function shareReceipt(node, orderNumber, extraText = '') {
    const { blob, filename } = await nodeToPngBlob(
        node,
        `BeautyByChancy-${orderNumber || 'receipt'}.png`
    );
    const file = new File([blob], filename, { type: 'image/png' });
    // Web Share API Level 2 (mobile Safari, Chrome Android)
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
            await navigator.share({
                title: `BeautyByChancy Receipt #${orderNumber}`,
                text: extraText || `My order from BeautyByChancy — #${orderNumber}`,
                files: [file],
            });
            return { shared: true };
        } catch (e) {
            // user cancelled — don't fall through to download
            if (e && e.name === 'AbortError') return { shared: false, cancelled: true };
        }
    }
    // Fallback: download the PNG
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return { shared: false, downloaded: true };
}
